var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phone"},[_c('first-screen'),_c('hot'),_c('excellent-course'),_c('teacher'),_c('project'),_c('choose-us'),_c('introversion'),_c('Footer'),_c('live'),_c('p-fix')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }